import React from 'react';
import { useToggleRefinement } from 'react-instantsearch-hooks-web';

const SearchFiltersToggle = ( props ) => {
	const { attribute, label, headerText } = props;

	const toggleApi = useToggleRefinement( {
		attribute,
	} );
	const { value, refine } = toggleApi;

	return (

		<div>
			{headerText && ( <div className='tw-font-bold tw-mb-2'>{headerText}</div> )}
			<label
				data-insights-filters={`${ attribute }:true`}
				className={`gtm-search-filter tw-cursor-pointer tw-mb-4 tw-font-normal tw-text-base tw-text-charcoal tw-flex`}
			>
				<input className="tw-mr-2" type="checkbox" checked={value.isRefined} onChange={( event ) => refine( { isRefined: ! event.target.checked } )} />
				{label}
			</label>
		</div>
	);
};

export default SearchFiltersToggle;
